import { Component, OnInit } from '@angular/core';
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { isUndefined } from "util";
import { Router , ActivatedRoute } from '@angular/router';

@Component({
  selector: 'forgotpassword',
  templateUrl: './forgotPassword.component.html',
  styleUrls: ['./forgotPassword.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  userName: string;
  password: string;
  reenterpassword: string;
  signUpFail: boolean;
  signUpFailMsg: string;
  email: string;
  color = 'green';
  isShowLoader = false;
  userNameEmpty;
  passwordEmpty;
  signUpCode: string;
  signUpCodeEmpty: string;

  constructor(private restApiService: RestApiService, private router: Router , private route: ActivatedRoute) {
    this.signUpFail = false;
    this.signUpFailMsg = "";

  }

  ngOnInit() {
    // this.userName = "+91";
    this.userName = this.route.queryParams['_value']['email'];
  }

  signUpRequest() {
    if (this.userName == null || isUndefined(this.userName) || this.userName == "") {
      this.userNameEmpty = "on-error";
      this.passwordEmpty = "";
      return;
    }
    else if (this.password == null || isUndefined(this.password) || this.password == "") {
      this.userNameEmpty = "";
      this.passwordEmpty = "on-error";
      return;
    }
    else if (this.reenterpassword == null || isUndefined(this.reenterpassword) || this.reenterpassword == ""||this.reenterpassword!=this.password) {
      this.userNameEmpty = "";
      this.passwordEmpty = "on-error";
      return;
    }
    else if (this.signUpCode == null || isUndefined(this.signUpCode) || this.signUpCode == "") {
      this.userNameEmpty = "";
      this.passwordEmpty = "";
      this.signUpCodeEmpty = "on-error";
      return;
    }
    else {
      this.userNameEmpty = "";
      this.passwordEmpty = "";
      this.signUpCodeEmpty = "";
      this.signUpFailMsg = "";
      this.isShowLoader = true;

      this.restApiService.confirmForgotPassword(this.userName, this.password,this.signUpCode).subscribe(
        result => {
          // console.log(result);
          if (result.success) {
            this.isShowLoader = false;
            // this.router.navigateByUrl('/logIn', { queryParams: { userName: this.userName } });
            this.router.navigate(['/logIn'],{ queryParams: { email: this.userName} })
          }
          else {
            //signUp failed
            this.isShowLoader = false;
            this.signUpFailMsg ='Password reset failed';
            this.signUpFail = true;
            // console.log(this.signUpFailMsg);
          }

        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/forgotPassword/forgotPassword.component.ts